import React, { Fragment, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Form, FormGroup, ModalBody, ModalHeader } from 'reactstrap';
import { OwnerType } from '../../../constants/Enums';
import { addReferenceTree } from '../../../redux/actions/analysistree';
import useDebounce from '../../helpers/Debouncer';
import { nameFiltering } from '../../helpers/genericHelper';
import DraggableModal from './DraggableModal';
import { InputTemplate } from './InputTemplate';

/**
 * Reference Modal
 *
 * A modal component used to add reference trees from existing nodes
 *
 *  @param modal boolean to display/hide modal
 *  @param toggle toggle for modal display
 *  @param parent the parent node for update/creation
 *
 */
const ControlCatalogModal = ({
  node,
  parent,
  toggle,
  modal,
  addReferenceTree,
  ControlCatalogs,
  defaultControlCatalogs,
}) => {
  const [filteredCatalogs, setFilteredCatalogs] = useState(ControlCatalogs);

  const defaultCatalog = (catalogs) => {
    let tree = undefined;
    if (node?.owner.owner_type === OwnerType.RefTree) {
      tree = catalogs.find((catalog) =>
        catalog.children.includes(node.owner.id)
      );
      return tree._id;
    } else {
      const defaultCatalog = defaultControlCatalogs?.find(
        (catalog) => catalog?.catalog_type === 'default'
      );
      tree = catalogs.find((catalog) => catalog?._id === defaultCatalog?._id);
      return tree?._id;
    }
  };

  const [formData, setFormData] = useState({
    name: node.name,
    description: node.description,
    catalog: undefined,
  });

  useEffect(() => {
    changeFormData({
      ...formData,
      catalog: defaultCatalog(filteredCatalogs),
    });
  }, []);

  const changeFilteredCatalogs = (catalogData) =>
    setFilteredCatalogs(catalogData);

  const changeFormData = (newFormData) => setFormData(newFormData);

  const [searchString] = useState('');
  const deboucedSearchString = useDebounce(searchString, 500);

  const onChange = (e) =>
    changeFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

  const onSubmit = async () => {
    addReferenceTree(formData, node, parent);
  };

  useEffect(() => {
    const filteredCatalogs = nameFiltering(
      ControlCatalogs,
      deboucedSearchString
    );
    changeFilteredCatalogs(filteredCatalogs);
  }, [deboucedSearchString]);

  const focusRef = useRef(null);
  useEffect(() => {
    if (modal) {
      setTimeout(() => {
        focusRef.current && focusRef.current.focus();
      }, 1);
    }
  }, [modal]);

  return (
    <Fragment>
      <DraggableModal isOpen={modal} toggle={toggle} backdrop='static'>
        <ModalHeader>
          <div className='modal-header'>Add Control to Catalogue</div>
        </ModalHeader>
        <div className='modal-line' />
        <ModalBody className='modal-body'>
          <Form>
            <FormGroup>
              <InputTemplate
                label='Catalog'
                type='select'
                name='catalog'
                value={formData.catalog}
                onChange={onChange}
                selectDefault
                innerRef={focusRef}
              >
                {filteredCatalogs.map((catalogItem) => {
                  return (
                    <option value={catalogItem._id}>{catalogItem.name}</option>
                  );
                })}
              </InputTemplate>
            </FormGroup>
            <FormGroup>
              <Button
                disabled={
                  formData.name === undefined || formData.catalog === undefined
                }
                type='submit'
                className='float-right btn-add'
                onClick={() => {
                  onSubmit();
                  toggle();
                }}
              >
                Save
              </Button>
              <Button className='float-right btn-danger' onClick={toggle}>
                Cancel
              </Button>
            </FormGroup>
          </Form>
        </ModalBody>
      </DraggableModal>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  controls: state.controls.controls,
  defaultControlCatalogs: state.project.control_catalogs,
  ControlCatalogs: state.profile.userControlCatalogs,
});
export default connect(mapStateToProps, {
  addReferenceTree,
})(ControlCatalogModal);
